import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { useStyles } from './styles';

const Props = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.arrayOf(PropTypes.node),
      ]).isRequired,
    }),
  ).isRequired,
};

export default function Faq({ items, titleFaq }) {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.titleFaq} variant="h2" align="center">
        {titleFaq || 'Frequently Asked Questions'}
      </Typography>

      {items.map((item, index) => (
        <Accordion key={index} className={classes.panelRoot}>
          <AccordionSummary
            classes={{ root: classes.panelSummary, expandIcon: classes.panelSummaryIcon }}
            expandIcon={
              <img
                src="/images/arrow-icon.svg"
                height="26"
                width="26"
                loading="lazy"
                alt="Expand icon"
              />
            }
          >
            <Typography className={classes.primaryColor}>
              <b>{item.question}</b>
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <div>
              {item.answer instanceof Array ? (
                item.answer.map((answer, answerIndex) => (
                  <Typography
                    key={answerIndex}
                    gutterBottom={answerIndex !== item.answer.length - 1}
                  >
                    {answer}
                  </Typography>
                ))
              ) : (
                <Typography>{item.answer}</Typography>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
}

Faq.propTypes = Props;
